import { PageLink } from '../../../../../../_metronic/layout/core'
import { API_URL } from '../../../../../../constants'

const LOGS_API = `${API_URL}/api/internal/logs`

export const EXTERNAL_TRANSACTIONS_API = `${LOGS_API}/external-transactions`
export const TRANSACTION_LOGS_API = `${LOGS_API}/transaction-logs`

export const EXTERNAL_TRANSACTIONS_BREADCRUMBS: Array<PageLink> = [
  {
    title: 'Внешние транзакции',
    path: '/logs/external-transactions',
    isSeparator: false,
    isActive: true,
  },
]

export const EXTERNAL_TRANSACTION_DETAIL_BREADCRUMBS: Array<PageLink> = [
  {
    title: 'Внешние транзакции',
    path: '/logs/external-transactions',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const DIRECTION_LABEL: Record<'in' | 'out', string> = {
  out: 'REQUEST',
  in: 'CALLBACK',
}

export const DIRECTION_BADGE: Record<'in' | 'out', string> = {
  out: 'badge-light-primary',
  in: 'badge-light-success',
}

export const SEARCH_FIELD_OPTIONS = [
  { label: 'ID тикета',     value: 'ticketToken' },
  { label: 'ID транзакции', value: 'merchantTransactionId' },
  { label: 'ID адаптера',   value: 'adapterTransactionId' },
] as const
